module.exports = __webpack_public_path__ + "static/media/034.9fb7c11e.jpg";